export const COMMON_INFO = {
  TERMINAL_ID: 300103, // 目前提单页使用
};

export const ERROR_CODE = {
  NOT_LOGIN: 50002,
};
